import React from "react";
import { Route, Switch } from "react-router-dom";
import Loadable from 'react-loadable';

import CircularProgress from "components/CircularProgress";
import Error404 from "../../components/ErrorPages/Error404";

const Dashboard = Loadable({
  loader: () => import('../../containers/GroupAdmin/Dashboard'),
  loading: CircularProgress,
});

const GroupTemplates = Loadable({
  loader: () => import('../../containers/GroupAdmin/GroupTemplates'),
  loading: CircularProgress,
});
const Worklist = Loadable({
  loader: () => import('../../containers/GroupAdmin/Worklist/index'),
  loading: CircularProgress,
});

const Parked = Loadable({
  loader: () => import('../../containers/GroupAdmin/Parked/index'),
  loading: CircularProgress,
});

const SubmittedForVerification = Loadable({
  loader: () => import('../../containers/GroupAdmin/SubmittedForVerification/index'),
  loading: CircularProgress,
});

const SubmittedToTypist = Loadable({
  loader: () => import('../../containers/GroupAdmin/SubmittedToTypist/index'),
  loading: CircularProgress,
});

const Locked = Loadable({
  loader: () => import('../../containers/GroupAdmin/Locked/index'),
  loading: CircularProgress,
});

const WorklistVisits = Loadable({
  loader: () => import('../../containers/WorklistVisits/index'),
  loading: CircularProgress,
});

const ReportViewer = Loadable({
  loader: () => import('../../containers/GroupAdmin/ReportViewer'),
  loading: CircularProgress,
});
const Library = Loadable({
  loader: () => import('../../containers/Library/Dashboard'),
  loading: CircularProgress,
});
const MyLibrary = Loadable({
  loader: () => import('../../containers/Library/MyLibrary/index'),
  loading: CircularProgress,
});
const AllCases = Loadable({
  loader: () => import('../../containers/Library/AllCases/index'),
  loading: CircularProgress,
});
const NewCases = Loadable({
  loader: () => import('../../containers/Library/NewCases/index'),
  loading: CircularProgress,
});
const SearchVisit = Loadable({
  loader: () => import('../../containers/SearchVisit/index'),
  loading: CircularProgress,
});
const VisitReportViewer = Loadable({
  loader: () => import('../../containers/SearchVisit/ReportViewer/index'),
  loading: CircularProgress,
});


const GroupAdmin = ({ match }) => (
  <Switch>
    <Route exact path={`${match.url}/dashboard`} component={Dashboard} />
    <Route exact path={`${match.url}/group-templates`} component={GroupTemplates} />
    <Route exact path={`${match.url}/worklist`} component={Worklist} />
    <Route exact path={`${match.url}/parked`} component={Parked} />
    <Route exact path={`${match.url}/submitted-for-verification`} component={SubmittedForVerification} />
    <Route exact path={`${match.url}/submitted-to-typist`} component={SubmittedToTypist} />
    <Route exact path={`${match.url}/locked`} component={Locked} />
    <Route exact path={`${match.url}/worklist-visits`} component={WorklistVisits} />
    <Route exact path={`${match.url}/report-viewer`} component={ReportViewer} />
    <Route exact path={`${match.url}/library`} component={Library} />
    <Route exact path={`${match.url}/my-library`} component={MyLibrary} />
    <Route exact path={`${match.url}/all-cases`} component={AllCases} />
    <Route exact path={`${match.url}/new-cases`} component={NewCases} />
    <Route exact path={`${match.url}/search-visit`} component={SearchVisit} />
    <Route exact path={`${match.url}/visit-report-viewer`} component={VisitReportViewer} />
    <Route component={() => <Error404 redirectTo="/groupadmin/dashboard" />} />
  </Switch>
);

export default GroupAdmin;
